import React, { ReactNode } from 'react'

interface PortalHostProps {
  id: string
  children?: ReactNode
}

export const PortalHost = React.forwardRef<HTMLDivElement, PortalHostProps>(
  ({ id, children, ...rest }, ref) => {
    return (
      <div ref={ref} id={id} {...rest}>
        {children}
      </div>
    )
  }
)

PortalHost.displayName = 'PortalHost'
